import React, { useState, useEffect } from "react";
import Selector from "./Selector";
import IX from "./IX";
import NonIX from "./NonIX";
import DirectTransport from "../backend-files/helpers/data/Απευθείας Μετακίνηση.json";
import envCostAirplanesjson from "../backend-files/helpers/data/Περιβαλλοντικό Κόστος_Αεροπορικές.json";
import envCostSeajson from "../backend-files/helpers/data/Περιβαλλοντικό Κόστος_Θαλάσσιες.json";
import envCostsIXjson from "../backend-files/helpers/data/Περιβαλλοντικό Κόστος_ΙΧ.json";
import envCostKTELjson from "../backend-files/helpers/data/Περιβαλλοντικό Κόστος_ΚΤΕΛ.json";
import envCostTrainjson from "../backend-files/helpers/data/Περιβαλλοντικό Κόστος_Σιδηρόδρομος.json";
import "./MeanOfTransport.css";

function MeanOfTransport({
  orderNumber,
  onCommisionChange,
  onTimeChange,
  onEnvCostChange,
}) {
  const [showMeansOptions, setShowMeansOptions] = useState(false);
  const [means, setMeans] = useState("");
  const [startSelectorValue, setstartSelectorValue] = useState("");
  const [endSelectorValue, setendtSelectorValue] = useState("");

  const [commision, setCommision] = useState("");
  const [time, setTime] = useState("");
  const [envCost, setEnvCost] = useState(0);
  const [submitted, setSubmitted] = useState(false); // New state variable

  // Grab values of cities for dropdowns
  var temp = [];
  for (var k = 0; k < Object.keys(DirectTransport).length; k++) {
    temp.push(DirectTransport[k]["Προέλευση"]);
  }

  // Remove duplicates by converting list to set
  const unique_list = [...new Set(temp)];

  // Map value and label in order to ger different key values
  let SelectionsData = unique_list.map((x) => ({ value: x, label: x }));
  // Data for Start and Destination Selectors
  const startSelector = {
    title: "Εκκίνηση",
    defaultText: "Επιλογή από τη λίστα",
    options: SelectionsData,
  };

  const destinationSelector = {
    title: "Προορισμός",
    defaultText: "Επιλογή από τη λίστα",
    options: SelectionsData,
  };

  useEffect(() => {
    switch (means) {
      case "ΙΧ":
        setEnvCost(
          getEnvironmentalCost(
            envCostsIXjson,
            startSelectorValue,
            endSelectorValue
          )
        );
        break;
      case "Αεροπλάνο":
        setEnvCost(
          getEnvironmentalCost(
            envCostAirplanesjson,
            startSelectorValue,
            endSelectorValue
          )
        );
        break;
      case "ΚΤΕΛ":
        setEnvCost(
          getEnvironmentalCost(
            envCostKTELjson,
            startSelectorValue,
            endSelectorValue
          )
        );
        break;
      case "Πλοίο":
        setEnvCost(
          getEnvironmentalCost(
            envCostSeajson,
            startSelectorValue,
            endSelectorValue
          )
        );
        break;
      case "Τρένο":
        setEnvCost(
          getEnvironmentalCost(
            envCostTrainjson,
            startSelectorValue,
            endSelectorValue
          )
        );
        break;
      default:
    }
  }, [startSelectorValue, endSelectorValue, means]);

  function getEnvironmentalCost(json, origin, destination) {
    for (let i = 0; i < json.length; i++) {
      const data = json[i];
      if (data["Προέλευση"] === origin && data["Προορισμός"] === destination) {
        if (data["Περιβαλλοντικό Κόστος"] !== "-") {
          return data["Περιβαλλοντικό Κόστος"];
        } else {
          return 0;
        }
      }
    }
    return 0; // Return null if no matching data is found
  }

  useEffect(() => {
    setCommision(""); // Zero out the commision value when means changes
  }, [means]);

  const handleChange = (event) => {
    const inputValue = event.target.value;

    // Only allow positive numeric values
    if (/^\d*$/.test(inputValue)) {
      setTime(inputValue);
      onTimeChange(orderNumber, inputValue); // Pass the orderNumber and updated time value to the parent component
    }
  };

  const handleCommisionChange = (newCommision) => {
    // Update the commision value received from the child
    setCommision(newCommision);
    onCommisionChange(orderNumber, newCommision);
  };

  const handleButtonClick = () => {
    // Perform any necessary action when the button is clicked
    setShowMeansOptions(true);
  };

  const handleButtonClick2 = () => {
    onEnvCostChange(envCost);
    setSubmitted(true); // Set the submitted state to true when the button is clicked
  };

  let ConnectedStartMeansSelector = {
    title: "Επιλέξτε Μέσο",
    defaultText: "Επιλογή από τη λίστα",
    options: [
      { value: "ΙΧ", label: "ΙΧ" },
      { value: "Αεροπλάνο", label: "Αεροπλάνο" },
      { value: "ΚΤΕΛ", label: "ΚΤΕΛ" },
      { value: "Πλοίο", label: "Πλοίο" },
      { value: "Τρένο", label: "Τρένο" },
    ],
  };

  // Clear all components when submitted is true
  if (submitted) {
    return (
      <div
        style={{
          marginLeft: "40px",
          fontSize: "27px",
        }}
      >
        Μέσο {orderNumber}: {means} <br></br>
        Xρόνος: {time} λεπτά <br></br>
        Εκκίνση: {startSelectorValue} <br></br>
        Προοριμός: {endSelectorValue}
        <hr
          style={{
            color: "white",
            backgroundColor: "white",
            height: "1px",
            width: "200px",
          }}
        ></hr>
      </div>
    );
  }

  return (
    <div className="means">
      <h1>Μέσο {orderNumber}</h1>
      <input
        type="text"
        value={time}
        onChange={handleChange}
        placeholder="Εισάγετε τον χρόνο μετακίνησης με το μέσο (λεπτά)."
        style={{ width: "400px" }}
      />

      <div style={{ display: "flex", marginLeft: "-40px" }}>
        <Selector props={startSelector} onSelect={setstartSelectorValue} />
        <Selector props={destinationSelector} onSelect={setendtSelectorValue} />
      </div>

      <button onClick={handleButtonClick} style={{ marginBottom: "10px" }}>
        Εισαγωγή
      </button>
      <div style={{ marginLeft: "-40px" }}>
        {showMeansOptions ? (
          <Selector props={ConnectedStartMeansSelector} onSelect={setMeans} />
        ) : (
          <></>
        )}
        {means === "ΙΧ" && means !== "" ? (
          <IX onCommisionChange={handleCommisionChange} time={time}></IX>
        ) : (
          <></>
        )}
        {means === "Αεροπλάνο" && means !== "" ? (
          <NonIX means={means} onCommisionChange={handleCommisionChange}>
            {" "}
          </NonIX>
        ) : (
          <></>
        )}
        {means === "ΚΤΕΛ" && means !== "" ? (
          <NonIX means={means} onCommisionChange={handleCommisionChange}>
            {" "}
          </NonIX>
        ) : (
          <></>
        )}
        {means === "Πλοίο" && means !== "" ? (
          <NonIX
            means={means}
            onCommisionChange={handleCommisionChange}
          ></NonIX>
        ) : (
          <></>
        )}
        {means === "Τρένο" && means !== "" ? (
          <NonIX
            means={means}
            onCommisionChange={handleCommisionChange}
          ></NonIX>
        ) : (
          <></>
        )}
      </div>
      <br></br>
      <button onClick={handleButtonClick2} style={{ marginTop: "10px" }}>
        Οριστικοποίηση
      </button>
    </div>
  );
}

export default MeanOfTransport;
